import { Choice, isMultiCharity } from '@lib/services'
import { useCheckoutPlan, MyFridaysOption, MTDtracking } from '@shamaazi/mytennights'
import { type FC, useState } from 'react'
import { Step } from '~/components/CheckoutProgress'
import { PageForCheckoutFlow } from '~/components/Page'
import { Button } from '@lib/components'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '@lib/hooks'
import arrowRight from '~/assets/icons/arrow-right-white.svg'
import { MytennightsTestId } from '@lib/testing'

export const Extras: FC<{ nextPage: string }> = ({ nextPage }) => {
  const { plan, setPlan } = useCheckoutPlan()
  const navigate = useNavigate()
  const { user } = useAuth()
  const [fgError, setFGError] = useState<string>('')

  const disableContinueButton = plan.fridayGivingOptIn === '' || (plan.fridayGivingOptIn === Choice.yes && plan.fridayGiving === 0)

  const setFridayGivingOption = (optIn: string, amount: number): void => {
    setFGError('')
    setPlan({ ...plan, fridayGivingOptIn: optIn, fridayGiving: amount })
  }

  return <PageForCheckoutFlow progressBarStep={Step.Extras} skinny={true} withQurbani={isMultiCharity(plan.charity.charity_id)}>
        <div className="w-full flex-grow flex flex-col items-center justify-between gap-y-4">
            <h1 className="text-mtd-secondary-5 text-mtd-h2 font-bold hidden md:block leading-none py-2">Help your good deeds go further</h1>
            <MyFridaysOption fGError={fgError} setFGError={setFGError} planOptIn={plan.fridayGivingOptIn} planAmount={plan.fridayGiving} setFridayGivingOption={setFridayGivingOption} currency={plan.charity.currency} />
        </div>
        <Button className="w-full text-mtd-h2 font-bold flex flex-row items-center justify-center gap-x-3 mt-12 md:mt-10" data-test-id={MytennightsTestId.continueButton} variant="mtd-primary" disabled={disableContinueButton || fgError !== ''} onClick={() => {
          navigate(nextPage)
          MTDtracking.confirmMyFridays(user?.email, plan, plan.fridayGiving)
        }}>CONTINUE
          <img src={arrowRight} alt="arrow right" className="w-6 h-6" /></Button>
    </PageForCheckoutFlow>
}
